/*
* REGRAS:
* - a div a ser clonada deverá ter a classe multi-nome
* - a div deverá ter o hidden multi-nome-cont começando com zero
* - o botão de adicionar terá a classe multi-nome-add
* - o botão de deletar terá a classe multi-nome-del
*/

window.addEventListener('DOMContentLoaded', () => {
    // multi('subcategory', true);
    // multi('attachment', true);
    // multi('card', true);
    // multi('data-bank', true);
    // multi('email', true);
    // multi('phone', true);
    // multi('plan-service', true);
    // multi('person-contact', true);
    multi('coverage', true);
    multi('animal', true);
    multi('transaction_attachment', true);
});

// Encontra o contêiner mais próximo do botão clicado que já contém tanto o
// item quanto o contador. Isso evita que, quando o mesmo "multi-nome" existe
// duplicado na página (ex: blocos alternáveis Customer/Prospect dentro de
// Proposal), a operação afete o bloco errado (escondido/desabilitado).
// Se não encontrar um contêiner mais específico, cai no documento inteiro,
// mantendo o comportamento original para os casos com um único bloco.
function findMultiScope(button, item, contEl){
    var $scope = $(button).parents().filter(function(){
        return $(this).find(item).length > 0 && $(this).find(contEl).length > 0;
    }).first();

    return $scope.length ? $scope : $(document);
}

function multi(nome, enableDel){
    var item      = '.multi-' + nome;
    var addButton = '.multi-' + nome + '-add';
    var delButton = '.multi-' + nome + '-del';
    var contEl    = '.multi-' + nome + '-cont';

    //ao clicar no botão de adicionar
    $(document).on('click', addButton, function(){
        var $scope = findMultiScope(this, item, contEl);

        //incrementa-se o cont
        var cont = $scope.find(contEl).val();
        cont = Math.floor(Math.random() * 1000) + 1;
        $scope.find(contEl).val(cont);

        //clona-se a div
        var $lastItem = $scope.find(item).last();
        var clone = $lastItem.clone();

        //pra cada input, select e textarea
        clone.find('input, select, textarea, checkbox, label, hidden').each(function(index, el) {

            if($(this).is("label")) {
                // Atualizando o atributo for
                let new_for = $(this).attr("for").replace($(this).attr("for").match("[0-9]"), cont);
                $(this).attr("for", new_for);
            } else {
                //muda-se o id e o nome
                this.name = this.name.replace(this.name.match("[0-9]"), cont);
                this.id = this.id.replace(this.id.match("[0-9]"), cont);

                if( $(this).hasClass('complete-phone-ddd') ){
                    $(this).unmask();
                    $(this).inputmask({
                        mask: ["(99) 9999-9999", "(99) 99999-9999" ],
                        keepStatic: true
                    });
                } else if( $(this).hasClass('money') ){
                    $(this).unmask();
                    $(this).mask("000.000.000.000,00", {reverse: true});
                }  else if ($(this).hasClass('chosen') || $(this).hasClass('select2') || $(this).hasClass('select')) {
                    $(this).select2();
                    $(this).val('').trigger('change');
                    $(this).next().next().remove();
                } else if( $(this).hasClass('cep') ){
                    $(this).unmask();
                    $(this).inputmask({
                        mask: "99.999-999",
                        keepStatic: true,
                        positionCaretOnTab: true
                    });
                } else if( $(this).hasClass('cpf') ){
                    $(this).inputmask({
                        mask: "999.999.999-99",
                        keepStatic: true,
                        positionCaretOnTab: true
                    });
                } else if( $(this).hasClass('datepicker') ){
                    $(this).datepicker({
                        format: 'dd/mm/yyyy',
                        language: 'pt-BR',
                        todayHighlight: true
                    });

                    $(this).inputmask({
                        mask: "99/99/9999",
                        keepStatic: true,
                        positionCaretOnTab: true
                    });
                } else if( $(this).hasClass('datetimepicker') ){
                    flatpickr(this, settings.flatpickr);
                }
                if(!$(this).hasClass('hidden')){
                    //limpa o valor
                    this.value = '';
                }
                if($(this).is(":checkbox")) {
                    $(this).prop('checked', false);
                }
                // garante que o clone não herde o estado disabled do bloco
                // oculto de onde foi clonado (ex: bloco Prospect desabilitado)
                $(this).prop('disabled', false);
            }
        });

        //coloca-se no parent
        clone.appendTo( $lastItem.parent() );
        $('select').select2();
        $(".select2icon").select2({
            escapeMarkup: function (markup) { return markup; }
        });

        $(".money").maskMoney({
            prefix: "R$ ",
            showSymbol: true,
            decimal: ",",
            thousands: ".",
            symbolStay: true,
            selectAllOnFocus: true
        });

        //para não dar submit
        return false;
    });

    //caso o parâmetro de ativação do botão de exclusão do item seja falso, o gatilho de execução
    //deverá ser reescrito. Isso é útil para quando houverem outras operações além de remover o
    //item, como cálculos.
    if(enableDel){
        $(document).on('click', delButton, function() {
            var $scope = findMultiScope(this, item, contEl);

            //verificação que impede a exclusão de quando houve apenas um item
            if($scope.find(item).length > 1){
                //após o fade, remove o item
                $(this).parent().parent().fadeOut('fast', function(){
                    $(this).remove();
                });
            }
            return false;
        });
    }
}

// Usado em outros arquivos e em views (escopo de modulo do esbuild).
window.multi = multi;